.icon {
    width: 30px;
    height: 30px;
    margin-right: 10px;
}
